import React from 'react'
import { useTranslation } from 'react-i18next'
import LinkButton from 'srcReact/components/common2/LinkButton'

import styles from './styles.module.scss'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'

function ErrorFallback({ title, subTitle, className, isServerError = false }) {
  const { t } = useTranslation()
  return (
    <div className={`${styles.container} ${className}`}>
      <img src={`${config.assetUrl + '/images/Oops.png'}`} alt='' className={styles.img} />
      <h1 className={styles.title}>
        {isServerError ? t('errorPage.serverTitle') : title || t('errorPage.clientTitle')}
      </h1>
      <h2 className={styles.subtitle}>{subTitle || t('errorPage.subTitle')}</h2>
      <div className={styles.buttons}>
        <LinkButton
          size='large'
          reactLink={false}
          href={
            isUserAuthorized()
              ? `${location.protocol}//${location.hostname}/0/support`
              : `${location.protocol}//${location.hostname}/contact-us`
          }
          text={t('nav.contact')}
          style='secondary'
        />
        <LinkButton
          size='large'
          reactLink={false}
          href={`${location.protocol}//${location.hostname}/0/myhome`}
          text={t('global.gotoHome')}
        />
      </div>
    </div>
  )
}

export default ErrorFallback
